import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ITimelineGroup } from '../models/timeline-group';

@Component({
    selector: 'aa-timeline-group',
    templateUrl: './timeline-group.component.html',
    styleUrls: ['./timeline-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimelineGroupComponent implements OnInit
{
    @Input() tlGroup: ITimelineGroup;

    constructor() { }

    ngOnInit ()
    {
    }

}
